module.exports = __webpack_public_path__ + "instagram-9b29fd30.png";